import { useState, useEffect } from 'react'

interface ScrollState {
  isScrolled: boolean
  isCollapsed: boolean
  scrollDirection: 'up' | 'down'
  scrollY: number
}

export function useHeaderScroll(threshold = 100): ScrollState {
  const [state, setState] = useState<ScrollState>({
    isScrolled: false,
    isCollapsed: false,
    scrollDirection: 'up',
    scrollY: 0,
  })

  useEffect(() => {
    let lastScrollY = window.scrollY
    let ticking = false

    const update = () => {
      const currentY = window.scrollY
      const direction = currentY > lastScrollY ? 'down' : 'up'

      setState({
        isScrolled: currentY > 10,
        isCollapsed: currentY > threshold && direction === 'down',
        scrollDirection: direction,
        scrollY: currentY,
      })

      lastScrollY = currentY
      ticking = false
    }

    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(update)
        ticking = true
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [threshold])

  return state
}
